export const iconFontAwesomeHumanitarianTentArrowDownToLine = (
	<i className="fa-solid fa-tent-arrow-down-to-line"></i>
);
